import { useState } from "react";

import { toolbarActions  } from '../../services/EnumsService';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import {WorklogModal} from './WorklogModal'

export default function WorklogComponent({worklog}) {
    const [showWorklogModal, setShowWorklogModal] = useState(false)

    const editWorklogCloseAction = (()=>{
        setShowWorklogModal(false)
    })
    const editWorklogAction = (()=>{
        setShowWorklogModal(true)
    })

    const editWorklogModal = (<WorklogModal worklogId={worklog.id} closeAction={editWorklogCloseAction}></WorklogModal>)

    return (
        <div className>
            {showWorklogModal && editWorklogModal}
            <div key={worklog.id} className="flex flex-row">
                {worklog.details} {worklog.hours}h
                <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editWorklogAction}/>
            </div>
        </div>
    )
}